import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'usually_run'

export default function UsuallyRunPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue = value ? value : undefined

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const sex = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'Where do you usually run?',
      answer_key: sex.toLowerCase(),
      answer: sex,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.usuallyRun.heading')}
      buttons={[
        {
          text: t('pages.onboarding.usuallyRun.options.cityStreets'),
          value: 'cityStreets',
        },
        {
          text: t('pages.onboarding.usuallyRun.options.trailsParks'),
          value: 'trailsParks',
        },
        {
          text: t('pages.onboarding.usuallyRun.options.treadmill'),
          value: 'treadmill',
        },
        {
          text: t('pages.onboarding.usuallyRun.options.mixedTerrain'),
          value: 'mixedTerrain',
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
